import { render } from "./licenseInfo.windows.vue?vue&type=template&id=5f61e42a&scoped=true"
import script from "./licenseInfo.windows.vue?vue&type=script&lang=js"
export * from "./licenseInfo.windows.vue?vue&type=script&lang=js"

import "./licenseInfo.windows.vue?vue&type=style&index=0&id=5f61e42a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f61e42a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
